import { createSlice } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '../constants';

interface AuthDisclaimerState {
  mountedCount: number;
}

const initialState: AuthDisclaimerState = {
  mountedCount: 0,
};

const authDisclaimerSlice = createSlice({
  name: SLICE_NAMES.AUTH_DISCLAIMER,
  initialState,
  reducers: {
    disclaimerShown: state => {
      state.mountedCount += 1;
    },
    disclaimerHidden: state => {
      state.mountedCount = Math.max(0, state.mountedCount - 1);
    },
  },
});

export const { disclaimerShown, disclaimerHidden } =
  authDisclaimerSlice.actions;
export const authDisclaimerReducer = authDisclaimerSlice.reducer;
